const InvestorType = {
  GET_INVESTORS: 'GET_INVESTORS',
  GET_INVESTOR: 'GET_INVESTOR',
  UPDATE_INVESTOR: 'UPDATE_INVESTOR',
  CREDIT_CHARGE_MANUAL: 'CREDIT_CHARGE_MANUAL',
  GET_REQUEST_INVEST: 'GET_REQUEST_INVEST',
  GET_REQUEST_INVEST_BY_STARTUP_ID: 'GET_REQUEST_INVEST_BY_STARTUP_ID',
  GET_REQUEST_INVEST_BY_INVESTOR_ID: 'GET_REQUEST_INVEST_BY_INVESTOR_ID',
  CHANGE_REQUEST_INVEST: 'CHANGE_REQUEST_INVEST',
  GET_INVOICES_BY_ADMIN: 'GET_INVOICES_BY_ADMIN',
  CONFIRM_RECEIPT: 'CONFIRM_RECEIPT',
  CREATE_TICKET: 'CREATE_TICKET',
  REJECT_RECEIPT: 'REJECT_RECEIPT',
  GET_RECEIPT_INVOICES: 'GET_RECEIPT_INVOICES',
  CREDIT_REJECT_RECEIPT: 'CREDIT_REJECT_RECEIPT',
  GET_INVESTOR_MANAGERS: 'GET_INVESTOR_MANAGERS',
}

export default InvestorType
